/**
 * normalizeAccessGroups — convert the bootstrap `accessGroups` value to
 * a flat `{ permissionName: true }` boolean map.
 *
 * Live runtime shape (verified 2026-05-15 via React DevTools dump of
 * `state.calendarMonthBootstrap.accessGroups`): a string array of
 * permission names, e.g. `["dashboard", "calendarManageMy", ...]`.
 *
 * Downstream consumers (`buildCalendarPermissions`, `computeEventPermissions`)
 * read these as a boolean map (`accessGroups.calendarManageMy`). Without
 * normalization, every read returns `undefined` and every gate evaluates
 * to `false` — Edit / Cancel / Delete buttons stay hidden.
 *
 * Object inputs are passed through untouched (defensive — backend may
 * eventually ship the boolean map; either path stays correct).
 *
 * Extracted to a standalone module so `eventPermissions.js` can import
 * it without pulling React component dependencies (HeroUI / hooks /
 * routers) that other utils transitively touch via `buildCalendarPermissionsForOrg`.
 *
 * @module normalizeAccessGroups
 */

export function normalizeAccessGroups(accessGroups) {
	if (!accessGroups) return {};
	if (Array.isArray(accessGroups)) {
		const out = {};
		for (const name of accessGroups) {
			if (typeof name === 'string' && name.length > 0) out[name] = true;
		}
		return out;
	}
	if (typeof accessGroups === 'object') return accessGroups;
	return {};
}
